import { useCallback } from 'react';

import { AnnouncementBar } from '@/components/AnnouncementBar';
import { Button } from '@/components/Button';
import { HeaderSubPage } from '@/components/HeaderSubPage';
import { CheckIcon } from '@/components/Icons';
import { Navbar } from '@/components/Navbar';
import { Paragraph } from '@/components/Paragraph';
import { Spacer } from '@/components/Spacer';
import { useItineraryNavigation } from '@/hooks/useItineraryNavigation';
import { StyledFlexColumn } from '@/layout/FlexLayout';

import { StyledIconWrapper, StyledPageWidth } from './styles';

export function PaymentComfirmed() {
  const navigation = useItineraryNavigation();

  const navigateToOverview = useCallback(() => {
    navigation.to('overview');
  }, [navigation]);

  return (
    <>
      <AnnouncementBar />
      <Navbar variant="secondary" />
      <HeaderSubPage title="Payment Confirmation" emptyHeader />
      <StyledPageWidth>
        <StyledFlexColumn alignItems="center" gap={1} padding="2rem 0 4rem 0">
          <StyledIconWrapper>
            <CheckIcon size="2xl" color="white" />
          </StyledIconWrapper>
          <h1>You have paid!</h1>
          <Paragraph color="tertiary" textAlign="center">
            You have received a confirmation email of the payment. Check your inbox for more information regarding the
            remaining payment, to be paid no later than 60 days before departure.
          </Paragraph>
          <Spacer size="xl" />
          <Button size="small" variant="secondary" disableCapslock onClick={navigateToOverview}>
            &larr; Back to the travel overview
          </Button>
        </StyledFlexColumn>
      </StyledPageWidth>
    </>
  );
}
